import { trackEvent, identifyUser } from '../../../../../deepsea/scripts/modules/segment/utils';

const webinarTracking = () => {
  if (!document.querySelector('#webinar-content')) {
    return;
  }

  const qS = (el) => document.querySelector(el);
  const getUserType = () => localStorage.getItem('version');
  const getWebinarId = () => qS('[name="event_id"]').value;
  const getWebinarBusinessLine = () => window.webinarBusinessLine;
  const getWebinarApplicationType = () => 'oi_website';
  const getWebinarInputValue = (selector) => qS(`#webinar-content ${selector}`)?.value || false;

  const getWebinarFormData = () => {
    /* eslint-disable camelcase */
    // Disabling camelcase for mapping to 3rd party params.
    const first_name = getWebinarInputValue('#firstname');
    const last_name = getWebinarInputValue('#lastname');
    const email = getWebinarInputValue('#email');
    const company = getWebinarInputValue('#company');
    const company_postcode = getWebinarInputValue('#zip');
    const job_title = getWebinarInputValue('#jobtitle');
    const individual_fca_number = getWebinarInputValue('#std1');
    const company_fca_number = getWebinarInputValue('#companyindustry');

    // Only add truthy values to returned data.
    return {
      ...(first_name && { first_name }),
      ...(last_name && { last_name }),
      ...(email && { email }),
      ...(company && { company }),
      ...(company_postcode && { company_postcode }),
      ...(job_title && { job_title }),
      ...(individual_fca_number && { individual_fca_number }),
      ...(company_fca_number && { company_fca_number }),
    };
    /* eslint-enable camelcase */
  };

  const handleWebinarRegister = () => {
    const formData = getWebinarFormData();

    const eventData = {
      user_type: getUserType(),
      web_application_type: getWebinarApplicationType(),
      webinar_event_id: getWebinarId(),
      business_line: getWebinarBusinessLine(),
      ...formData,
    };

    trackEvent('webinar_registration_completed', eventData);

    if (formData.email) {
      identifyUser(formData.email, {
        email: formData.email,
        user_type: getUserType(),
        ...(formData.first_name && { first_name: formData.first_name }),
        ...(formData.last_name && { last_name: formData.last_name }),
      });
    }
  };

  /**
   * Add event listener to capture form submit.
   */
  qS('#webinar-content form').addEventListener('submit', handleWebinarRegister);
};

export default webinarTracking;
